import { ApexApiError } from 'apex-ui-services'
import { AxiosResponse } from 'axios'
import { Dispatch } from 'redux'
import { getAccountDetails as getAccountDetailsApi } from '../api'
import { HttpResponseStatusCodes } from '../constants'
import { ACCOUNT_RETRIEVAL_FAILED, TEMPORARILY_UNAVAILABLE } from './constants'

export const GET_ACCOUNT_DETAILS = 'GET_ACCOUNT_DETAILS'
export const GET_ACCOUNT_DETAILS_SUCCESS = 'GET_ACCOUNT_DETAILS_SUCCESS'
export const GET_ACCOUNT_DETAILS_FAILURE = 'GET_ACCOUNT_DETAILS_FAILURE'

export const getAccountDetails = (
  dispatch: Dispatch,
  accountNumber: string,
  onError: (error: string) => void
) => {
  dispatch({ type: GET_ACCOUNT_DETAILS, accountNumber })
  getAccountDetailsApi(accountNumber)
    .then((response: AxiosResponse) => {
      dispatch({
        type: GET_ACCOUNT_DETAILS_SUCCESS,
        accountDetails: { accountNumber, ...response.data },
      })
    })
    .catch((error: ApexApiError) => {
      const httpResponseStatus = error.response?.status
      const errorMessage =
        httpResponseStatus &&
        httpResponseStatus >= HttpResponseStatusCodes.InternalServerError
          ? TEMPORARILY_UNAVAILABLE
          : ACCOUNT_RETRIEVAL_FAILED
      dispatch({ type: GET_ACCOUNT_DETAILS_FAILURE })
      onError(errorMessage)
    })
}
